var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentBlankVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8441 23.4585H16.9475L19.3847 8.5896H23.2811L20.8441 23.4585Z",
    fill: "#C9C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9694 8.9531C34.2009 8.65225 32.9818 8.32007 31.4745 8.32007C27.6265 8.32007 24.9168 10.3447 24.9002 13.2392C24.8682 15.3748 26.8403 16.561 28.3152 17.2731C29.8227 18.0007 30.3352 18.4756 30.3352 19.1242C30.3198 20.1203 29.117 20.5795 27.9951 20.5795C26.4394 20.5795 25.6059 20.3428 24.3391 19.7886L23.826 19.551L23.2808 22.8887C24.1947 23.2995 25.8784 23.6641 27.6265 23.6801C31.7151 23.6801 34.3769 21.6868 34.4084 18.6022C34.424 16.9096 33.3826 15.6126 31.1376 14.5528C29.7748 13.8725 28.9402 13.4137 28.9402 12.7176C28.9561 12.0848 29.6461 11.4366 31.1845 11.4366C32.4513 11.4049 33.382 11.7053 34.0871 12.006L34.4395 12.1639L34.9694 8.9531Z",
    fill: "#C9C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1485 18.191C40.4694 17.3368 41.7042 14.0308 41.7042 14.0308C41.688 14.0625 42.0245 13.1608 42.2169 12.6073L42.4892 13.8884C42.4892 13.8884 43.2271 17.4476 43.3873 18.191C42.7783 18.191 40.9182 18.191 40.1485 18.191ZM44.9583 8.5896H41.9443C41.0149 8.5896 40.3087 8.85828 39.9077 9.82328L34.1199 23.4583H38.2084C38.2084 23.4583 38.8815 21.6231 39.0262 21.2279C39.4748 21.2279 43.4521 21.2279 44.0291 21.2279C44.141 21.7499 44.494 23.4583 44.494 23.4583H48.1019L44.9583 8.5896Z",
    fill: "#C9C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6928 8.5896L9.87679 18.7288L9.45979 16.6724C8.75429 14.2997 6.54167 11.7217 4.07251 10.4399L7.56786 23.4427H11.6884L17.8131 8.5896H13.6928Z",
    fill: "#C9C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33336 8.5896H0.0641366L0 8.89003C4.89038 10.1239 8.12919 13.0982 9.45987 16.673L8.09701 9.83947C7.87264 8.88982 7.18312 8.62093 6.33336 8.5896Z",
    fill: "#C9C4C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlankVisa);
export default __webpack_public_path__ + "static/media/payment-blank-visa.7a2d38043e7036fe67cdd3882ea86653.svg";
export { ForwardRef as ReactComponent };